// src/components/admin/view/firebase/firebase.js

const FIREBASE_PROJECT_ID = "jc-creations-2bd12";

const FIRESTORE_BASE_URL =
  "https://firestore.googleapis.com/v1/projects/" +
  FIREBASE_PROJECT_ID +
  "/databases/(default)/documents";


// =====================================================
// FIREBASE WEB API KEY
// =====================================================
//
// IMPORTANT:
// Replace this with your Firebase project's
// Web API Key.
//
// Firebase Console:
// Project Settings
// -> General
// -> Your apps
// -> Web app
// -> apiKey
//
// =====================================================

const FIREBASE_API_KEY = "AIzaSyA2H07mvgeeqxvxWpjjaU1lox-cn8y3PQQ";


// =====================================================
// FIREBASE ADMIN LOGIN
// =====================================================
//
// Email is fixed.
// Put your password below.
//
// DO NOT put the real password in chat.
// Replace YOUR_PASSWORD_HERE locally.
//
// =====================================================

const FIREBASE_ADMIN_EMAIL =
  "jccreationsbusiness@gmail.com";

const FIREBASE_ADMIN_PASSWORD =
  "JChost@99999";


// =====================================================
// LOCAL STORAGE KEYS
// =====================================================

const FIREBASE_ID_TOKEN_KEY =
  "jc_firebase_id_token";

const FIREBASE_REFRESH_TOKEN_KEY =
  "jc_firebase_refresh_token";

const FIREBASE_EXPIRES_AT_KEY =
  "jc_firebase_expires_at";


// =====================================================
// GET STORED TOKEN
// =====================================================

export const getFirebaseIdToken = () => {
  return localStorage.getItem(
    FIREBASE_ID_TOKEN_KEY
  );
};


// =====================================================
// CHECK TOKEN EXPIRATION
// =====================================================

const isTokenValid = () => {
  const token =
    localStorage.getItem(
      FIREBASE_ID_TOKEN_KEY
    );

  const expiresAt =
    localStorage.getItem(
      FIREBASE_EXPIRES_AT_KEY
    );

  if (!token || !expiresAt) {
    return false;
  }

  const expiry =
    parseInt(expiresAt, 10);

  if (isNaN(expiry)) {
    return false;
  }

  // Keep a 30 second safety buffer.
  return Date.now() < expiry - 30000;
};


// =====================================================
// CHECK FIREBASE AUTHENTICATION
// =====================================================

export const isFirebaseAuthenticated = () => {
  return isTokenValid();
};


// =====================================================
// FIREBASE LOGIN
// =====================================================

export const firebaseLogin = async () => {

  const response = await fetch(
    "https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=" +
      FIREBASE_API_KEY,
    {
      method: "POST",

      headers: {
        "Content-Type":
          "application/json",
      },

      body: JSON.stringify({
        email:
          FIREBASE_ADMIN_EMAIL,

        password:
          FIREBASE_ADMIN_PASSWORD,

        returnSecureToken: true,
      }),
    }
  );


  const data =
    await response.json();


  if (!response.ok) {

    let message =
      "Firebase authentication failed";


    if (
      data &&
      data.error &&
      data.error.message
    ) {
      message =
        data.error.message;
    }


    if (
      message ===
      "INVALID_LOGIN_CREDENTIALS"
    ) {
      message =
        "Invalid Firebase email or password";
    }

    if (
      message ===
      "EMAIL_NOT_FOUND"
    ) {
      message =
        "Firebase user does not exist";
    }

    if (
      message ===
      "INVALID_PASSWORD"
    ) {
      message =
        "Invalid Firebase password";
    }

    if (
      message ===
      "USER_DISABLED"
    ) {
      message =
        "Firebase user is disabled";
    }


    throw new Error(message);
  }


  if (
    !data ||
    !data.idToken
  ) {
    throw new Error(
      "Firebase did not return an ID token"
    );
  }


  // Firebase expiresIn is normally seconds.
  const expiresIn =
    parseInt(
      data.expiresIn || "3600",
      10
    );


  const expiresAt =
    Date.now() +
    expiresIn * 1000;


  localStorage.setItem(
    FIREBASE_ID_TOKEN_KEY,
    data.idToken
  );


  if (data.refreshToken) {
    localStorage.setItem(
      FIREBASE_REFRESH_TOKEN_KEY,
      data.refreshToken
    );
  }


  localStorage.setItem(
    FIREBASE_EXPIRES_AT_KEY,
    String(expiresAt)
  );


  return data;
};


// =====================================================
// FIREBASE LOGOUT
// =====================================================

export const firebaseLogout = () => {

  localStorage.removeItem(
    FIREBASE_ID_TOKEN_KEY
  );

  localStorage.removeItem(
    FIREBASE_REFRESH_TOKEN_KEY
  );

  localStorage.removeItem(
    FIREBASE_EXPIRES_AT_KEY
  );
};


// =====================================================
// GET FIRESTORE DOCUMENT
// =====================================================

export const getFirestoreDocument = async (
  collection,
  document
) => {

  const response =
    await fetch(
      FIRESTORE_BASE_URL +
        "/" +
        collection +
        "/" +
        document
    );


  if (!response.ok) {

    const errorText =
      await response.text();

    throw new Error(
      errorText ||
        "Firestore GET failed: " +
          response.status
    );
  }


  return response.json();
};


// =====================================================
// UPDATE FIRESTORE DOCUMENT
// =====================================================

export const updateFirestoreDocument = async (
  collection,
  document,
  fields
) => {

  // ==========================================
  // CHECK TOKEN
  // ==========================================

  if (!isFirebaseAuthenticated()) {

    throw new Error(
      "Firebase authentication expired"
    );
  }


  const token =
    getFirebaseIdToken();


  // ==========================================
  // FIRESTORE PATCH
  // ==========================================

  const response =
    await fetch(
      FIRESTORE_BASE_URL +
        "/" +
        collection +
        "/" +
        document,

      {
        method: "PATCH",

        headers: {
          "Content-Type":
            "application/json",

          Authorization:
            "Bearer " + token,
        },

        body: JSON.stringify({
          fields: fields,
        }),
      }
    );


  if (!response.ok) {

    const errorText =
      await response.text();


    throw new Error(
      errorText ||
        "Firestore PATCH failed: " +
          response.status
    );
  }


  return response.json();
};


// WEBPACK FOOTER //
// ./src/components/admin/view/firebase/firebase.js